module.exports = __webpack_public_path__ + "img/laurent.6b57fc45.svg";